import { jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { formatDate } from '../../utils/formatters';
import Text from '../elementals/text';
import styles from './styles.scss';
const cx = classnames.bind(styles);
export const OFFER_DATE_FORMAT = 'M/D/YY';
const MilestoneDate = ({ milestone }) => {
    if (milestone.completed_date) {
        return (_jsxs(Text, { size: 'small', className: cx('milestone-date'), children: ["Completed: ", formatDate(milestone.completed_date, OFFER_DATE_FORMAT)] }));
    }
    if (milestone.expected_completion_date) {
        return (_jsxs(Text, { size: 'small', className: cx('milestone-date'), children: ["Expected Completion:", ' ', formatDate(milestone.expected_completion_date, OFFER_DATE_FORMAT)] }));
    }
    if (milestone.last_updated_date) {
        return (_jsxs(Text, { size: 'small', className: cx('milestone-date'), children: ["Updated: ", formatDate(milestone.last_updated_date, OFFER_DATE_FORMAT)] }));
    }
    return null;
};
export default MilestoneDate;
//# sourceMappingURL=MilestoneDate.js.map